module.exports = __webpack_public_path__ + "img/coin-003.e161390b.svg";